export default __webpack_public_path__ + "static/media/deposit.736c5327.svg";